import html2canvas from 'html2canvas';

/**
 * Captures a DOM element as a PNG and triggers download.
 * @param {HTMLElement} element - The ref.current to capture
 * @param {string} filename - e.g. 'detox-resultado.png'
 */
export async function downloadCardAsImage(element, filename = 'clube-do-eu-detox.png') {
  const canvas = await html2canvas(element, {
    scale: 3,           // 3x resolution — sharp on retina / phone screens
    useCORS: true,
    backgroundColor: null,
    logging: false,
  });

  const link = document.createElement('a');
  link.download = filename;
  link.href = canvas.toDataURL('image/png');
  link.click();
}

/**
 * Captura um elemento DOM como PNG e compartilha via Web Share API.
 * Fallback: download direto se Web Share não estiver disponível.
 *
 * @param {HTMLElement} element - o ref.current a capturar
 * @param {string} filename     - ex: 'presenca-junho-2026.png'
 * @param {string} title        - texto do share dialog
 */
export async function shareCardAsImage(element, filename = 'clube-do-eu-presenca.png', title = 'Minha presença no Clube do Eu') {
  const canvas = await html2canvas(element, {
    scale: 3,
    useCORS: true,
    backgroundColor: null,
    logging: false,
  })

  const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'))
  const file = new File([blob], filename, { type: 'image/png' })

  if (navigator.share && navigator.canShare?.({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title })
      return
    } catch (err) {
      if (err.name === 'AbortError') return // usuária cancelou — não fazer fallback
      console.error('shareCardAsImage: Web Share failed, falling back to download', err)
    }
  }

  // Fallback: download
  const link = document.createElement('a')
  link.download = filename
  link.href = canvas.toDataURL('image/png')
  link.click()
}
